






























import Vue from 'vue';
import Component from 'vue-class-component';

import Calendar from "@/components/Calendar.vue";
import Tags from "@/components/Tags.vue";

import {updateJWT} from '../services/user';

import SidebarInst from '../services/sidebar';
import eventHub from '../services/eventHub';

const MINUTES = 60;
const SECONDS = 60;
const HOUR = MINUTES * SECONDS * 1000; // MS in an hour

@Component({
  components: {
    Calendar,
    Tags,
  },
  metaInfo: {
    title: 'Home',
  }
})
export default class Admin extends Vue {
  public auth_timer: any = null;
  public sidebar = SidebarInst;

  mounted() {
    // Get new JWT every hour
    this.auth_timer = setInterval(() => updateJWT(), HOUR);
  }

  today() {
    this.$router.push({name: 'Home Redirect'});
  }

  beforeDestroy() {
    if (this.auth_timer) {
      clearInterval(this.auth_timer);
    }
  }

  focusEditor() {
    eventHub.$emit('focusEditor');
  }
}
